import { React, useEffect, useState, useRef, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  JobCardContainer,
  JobListColumn,
  JobCardHeader,
  HaberForm,
  TableLayoutData,
} from "../../styledElements";
import { Button, PageHeader, Card, Radio, Table, Tooltip, Tabs, Menu, Dropdown } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import {
  getFilteredJobcards,
  getImageURL,
  getJobCardsInfo,
  searchJobCardByJobcardNo
} from "../../../Services/deckleMatchServices";
// import { getProductsData } from "../../../Services/productServices";
import moment from "moment";
import {
  TableList,
  RadioButtonStyle,
  Styled,
  StyledTab,
  DisabledButtonStyle
} from "../../pageStyled";
import InfiniteScroll from "react-infinite-scroll-component";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
// import { IMAGE_BASE_URL } from "../../../Constants/serverAddress";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import CardShimmer from "../../../Components/CardShimmer/cardShimmer";
import machineIcon from "../../../Assets/Icons/machine-icon.svg";
import { getUnitData } from "../../../Services/measurementService";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import { changeProductionJobCardState } from "../../../Services/productionPlanningServices";
import JobCardDataContext from "../../../ContextApi/JobCardDataContext";

const gridViewData = [
  {
    label: (
      <Tooltip
        placement="bottomRight"
        title={"View in grid mode"}
        className="edit-tooltip"
      >
        <Iconmoon icon="grid-chart" size={20} color="#EA655B" />
      </Tooltip>
    ),
    value: "grid",
  },
  {
    label: (
      <Tooltip
        placement="bottomRight"
        title={"View in tabular mode"}
        className="edit-tooltip"
      >
        <Iconmoon icon="table" size={20} color="#EA655B" />
      </Tooltip>
    ),
    value: "list",
  },
];

const Panes = Tabs.TabPane;

const JobCardsData = (props) => {
  const { storedAppliedFilters, setStoredAppliedFilters, storedFilterTags, setStoredFilterTags, storeModifiedFilterLabel, setStoreModifiedFilterLabel, isAllFilterApplied, setIsAllFilterApplied } = useContext(JobCardDataContext)
  const [modifiedFilterLabel, setModifiedFilterLabel] = useState(storeModifiedFilterLabel);
  const navigate = useNavigate();
  // const [products, setProducts] = useState();
  // const [jobcards, setJobCards] = useState();
  const [pendingCards, setPendingCards] = useState([]);
  const [rejectedCards, setRejectedCards] = useState([]);
  const [approvedCards, setApprovedCards] = useState([]);
  const [inProductionCards, setInProductionCards] = useState([]);
  const [completeCards, setCompleteCards] = useState([]);

  /*------------------------------//ERP Integration related changes---------------------------------------*/
  const [activeJobcards, setActiveJobCards] = useState([]);
  const [cancelledJobcards, setCancelledJobCards] = useState([]);
  const [underReviewJobcards, setUnderReviewJobCards] = useState([]);
  const [orderManagementSettings, setOrderManagementSettings] = useState(JSON.parse(localStorage.getItem("order-management-settings")))
  const [deckleManagementSettings, setDeckleManagementSettings] = useState()
  /*------------------------------------------------------------------------------------------------------*/

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [settingsData, setSettingsData] = useState(
    JSON.parse(localStorage.getItem("setting-data"))
  );
  const [gridView, setGridView] = useState(true
    // !JSON.parse(localStorage.getItem("jobCard_tabularView"))
  );
  const [totalRecords, setTotalRecords] = useState();
  const [jobCardsList, setJobCardsList] = useState();
  const [unitData, setUnitData] = useState();
  const [tableData, setTableData] = useState();
  const [tableJobCardState, setTableJobCardState] = useState();
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    size: 10,
  });
  const [coloumnDataJobCards, setColoumnDataJobCards] = useState(
    orderManagementSettings?.fetch_balance_quantity?.value
      ? [
        {
          state: "active",
          classname: "completed-job-cards",
          heading: "Active Job Cards",
          jobcards: activeJobcards,
          hasMore: true,
          currentPage: 1,
        },
        {
          state: "under_review",
          classname: "in-production",
          heading: "Under Review Job Cards",
          jobcards: underReviewJobcards,
          hasMore: true,
          currentPage: 1,
        },

        {
          state: "completed",
          classname: "completed-job-cards",
          heading: "Completed Job Cards",
          jobcards: completeCards,
          hasMore: true,
          currentPage: 1,
        },
        {
          state: "cancel",
          classname: "completed-job-cards",
          heading: "Cancelled Job Cards",
          jobcards: cancelledJobcards,
          hasMore: true,
          currentPage: 1,
        },

      ]
      : [
        {
          state: "pending",
          classname: "pending-for-approval",
          heading: "Pending for approval",
          jobcards: pendingCards,
          hasMore: true,
          currentPage: 1,
        },
        {
          state: "rejected",
          classname: "rejected-job-cards",
          heading: "Rejected Job Cards",
          jobcards: rejectedCards,
          hasMore: true,
          currentPage: 1,
        },
        {
          state: "approved",
          classname: "approved-job-cards",
          heading: "Approved Job Cards",
          jobcards: approvedCards,
          hasMore: true,
          currentPage: 1,
        },
        {
          state: "in_production",
          classname: "in-production",
          heading: "In Production",
          jobcards: inProductionCards,
          hasMore: true,
          currentPage: 1,
        },
        {
          state: "completed",
          classname: "completed-job-cards",
          heading: "Completed Job Cards",
          jobcards: completeCards,
          hasMore: true,
          currentPage: 1,
        },
      ]
  );
  const [appliedFilters, setAppliedFilters] = useState(
    storedAppliedFilters?.length > 0
      ? [...storedAppliedFilters]
      : isAllFilterApplied ? [] : [{
        type: "updated_date",
        start_date: moment().subtract(15, "days").format("YYYY-MM-DD"),
        end_date: moment().add(1, "day").format("YYYY-MM-DD"),
      }]
  );
  const [filterTags, setFilterTags] = useState([...storedFilterTags]);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [loadings, setLoadings] = useState(true);
  const scrollContainerRef = useRef(null);
  const titleRef = useRef(null);
  const tabRef = useRef(null);
  const searchRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, tabs: 95, search: 140, table: 226 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;
      const tabsHeight = tabRef.current?.offsetHeight || 0;
      const searchHeight = searchRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        tabs: baseTop + titleHeight,
        search: baseTop + titleHeight + tabsHeight,
        table: baseTop + titleHeight + tabsHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);
    if (tabRef.current) observer.observe(tabRef.current);
    if (searchRef.current) observer.observe(searchRef.current);

    return () => observer.disconnect();
  }, []);

  const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);
  const format = settingsData?.settings?.product_spec?.format || "";
  const tabHead = orderManagementSettings?.fetch_balance_quantity?.value ?
    [
      { key: 0, title: "Active", state: "active" },
      { key: 1, title: "Under Review", state: "under_review" },
      { key: 2, title: "Completed", state: "complete" },
      { key: 3, title: "Cancelled", state: "cancel" },

    ]
    :
    [
      { key: 0, title: "Pending for approval", state: "pending" },
      { key: 1, title: "Rejected", state: "rejected" },
      { key: 2, title: "Approved", state: "approved" },
      { key: 3, title: "In Production", state: "in_production" },
      { key: 4, title: "Completed", state: "complete" },
    ];
  useEffect(() => {
    (async () => {
      const orderMangSettings = await getWorkflowSettings("order_management");
      setOrderManagementSettings(orderMangSettings?.data);
      // setTableJobCardState(orderMangSettings.data.fetch_balance_quantity.value ? 'active' : 'pending');
      const deckleMangSettings = await getWorkflowSettings("deckle_management");
      setDeckleManagementSettings(deckleMangSettings?.data);
    })();
  }, []);
  useEffect(() => {
    (async () => {
      await getUnitData()
        .then((response) => {
          let data = response.data;
          setUnitData(data);
        })
        .catch((error) => {
          console.log(error);
        });
    })();
  }, []);

  const getJCCode = (str) => {
    if (str) {
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  }

  const handleViewChange = (e) => {
    console.log(e);

    setLoadings(true);
    if (e.target.value === "grid") {
      setGridView(true);
      setTableJobCardState();
      // localStorage.setItem("jobCard_tabularView", "false");
    } else {
      setTableJobCardState(orderManagementSettings?.fetch_balance_quantity.value ? 'active' : 'pending');
      setGridView(false);
      setPaginationParams({
        page: 1,
        size: 10,
      });
      // localStorage.setItem("jobCard_tabularView", "true");
    }
    // setAppliedFilters([
    //   {
    //     type: "updated_date",
    //     start_date: moment().subtract(15, "days").format("YYYY-MM-DD"),
    //     end_date: moment().add(1,"day").format("YYYY-MM-DD"),
    //   },
    // ]);
    // setFilterTags([]);
    // setModifiedFilterLabel("Last 15 days")
    setSearchValue()
  };

  const onChange = (pagination, filters, sorter, extra, orderState) => {
    // setPaginationParams({
    //   page: 1,
    //   size: 10,
    // });
    setPaginationParams({
      page: pagination.current,
      size: pagination.pageSize,
    });
  };

  const handleTabChange = (key) => {
    setLoadings(true);
    setTableJobCardState(tabHead[key].state);
    setPaginationParams({
      page: 1,
      size: 10,
    });
    // setFilterTags([]);
    // setAppliedFilters([{
    //   type: "updated_date",
    //   start_date: moment().subtract(15,"days").format("YYYY-MM-DD"),
    //   end_date: moment().add(1,"day").format("YYYY-MM-DD")
    // }]);
    // setModifiedFilterLabel("Last 15 days")
    setSearchValue()
  };

  const applyfilter = (filter) => {
    let temp = appliedFilters.length > 0 ? appliedFilters : storedAppliedFilters;
    let alreadySetFilter = false;
    if (filter.type == 'updated_date' && filter.start_date == "Invalid date") {
      removeFilter(filter);
      setIsAllFilterApplied(true)
      return;
    }
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setStoredAppliedFilters(tempVar);
    setIsAllFilterApplied(false);
    setFilterTags(tempVar.filter((item) => item.type != "updated_date").map(formatFilters));
    setStoredFilterTags(tempVar.filter((item) => item.type != "updated_date").map(formatFilters));
    setPaginationParams({
      page: 1,
      size: 10,
    });
  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "machine_type":
        const typeValue =
          item.machine_type === "rewinder"
            ? "Rewinding"
            : item.order_type === "cutter"
              ? "Cutting"
              : "Rewinding or Cutting";
        return {
          type: item.type,
          formattedType: "Finishing Process Type",
          operand: "equals",
          value: typeValue,
          // tooltip: `Order Type equals ${typeValue}`,
        };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "grade_quality":
        const gradeValue =
          item.grades.length > 1
            ? `${item.grades[0].grade}(${item.grades[0].qualities.join()}) or ${item.grades.length - 1
            } others`
            : `${item.grades[0].grade}` + (item.grades[0].qualities?.length ? `"(${item.grades[0].qualities.join()})"` : ``);
        return {
          type: item.type,
          formattedType: "Grade",
          operand: "-",
          value: gradeValue,
        };
      case "gsm":
        const gsmValue =
          item.operator === "in_range"
            ? `${item.min_gsm} and ${item.max_gsm}`
            : `${item.gsm}`;
        const gsmOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equal to"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "GSM",
          operand: gsmOperand,
          value: gsmValue,
          // tooltip: `GSM ${gsmOperand} ${gsmValue}`
        };
      case "burst_factor":
        const bfValue =
          item.operator === "in_range"
            ? `${item.min_burst_factor} and ${item.max_burst_factor}`
            : `${item.burst_factor}`;
        const bfOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equal to"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "Burst factor",
          operand: bfOperand,
          value: bfValue,
          // tooltip: `Burst factor ${bfOperand} ${bfValue}`
        };
      case "reel_od":
        const reelOdValue =
          item.operator === "in_range"
            ? `${item.min_reel_od} and ${item.max_reel_od}`
            : `${item.reel_od}`;
        const reelOdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equal to"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "Reel OD",
          operand: reelOdOperand,
          value: reelOdValue,
          // tooltip: `Reel OD ${reelOdOperand} ${reelOdValue}`
        };
      case "core_id":
        const coreIdValue =
          item.operator === "in_range"
            ? `${item.min_core_id} and ${item.max_core_id}`
            : `${item.core_id}`;
        const coreIdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equal to"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "Core ID",
          operand: coreIdOperand,
          value: coreIdValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`
        };
    }
  };

  const removeFilter = (filter) => {

    const temp = appliedFilters.length > 0 ? appliedFilters : storedAppliedFilters;
    const filterList = temp.filter((item) => {
      return item.type !== filter.type;
    });

    const tags = filterTags.length > 0 ? filterTags : storedFilterTags
    const formattedFilterList = tags.filter((item) => {
      return item.type !== filter.type;
    });

    setFilterTags(formattedFilterList);
    setStoredFilterTags(formattedFilterList);

    setAppliedFilters(filterList);
    setStoredAppliedFilters(filterList);

    setPaginationParams({
      page: 1,
      size: 10,
    });
  };

  // const fetchJobCardsList = async (params, state) => {
  //   console.log();

  //   try {
  //     setLoadings(true);
  //     const jobCardsData = await getJobCardsInfo(params, state);
  //     if(!jobCardsData[state]?.length){
  //       setEmptyStateLabel("noData");
  //     }
  //     else{
  //       setEmptyStateLabel();
  //     }
  //     setTotalRecords(jobCardsData.total_jobcards);
  //     setJobCardsList(jobCardsData[state]);
  //     setLoadings(false);
  //   } catch (error) {
  //     console.log(error);
  //     setEmptyStateLabel("connectionAPIError");
  //   }
  // };
  useEffect(() => {
    fetchFilteredJobCards();
  }, [searchValue, appliedFilters, paginationParams, tableJobCardState, orderManagementSettings, gridView])

  const fetchFilteredJobCards = () => {
    setLoadings(true);
    const filter = appliedFilters.length > 0 ? appliedFilters : storedAppliedFilters;
    getFilteredJobcards(paginationParams, filter, tableJobCardState, searchValue)
      .then(async (response) => {
        setTotalRecords(response.data.total_jobcards);
        if (!gridView) {
          if (response.data[tableJobCardState].length == 0)
            setEmptyStateLabel("noData");
          setJobCardsList(response.data[tableJobCardState]);
        }
        else {
          if (Object.keys(response.data.jobcards).every(item => response.data.jobcards[item].length == 0))
            setEmptyStateLabel("noData")
          else {
            setEmptyStateLabel();
            // Object.keys(response?.data?.jobcards).forEach((item)=>{
            //   handleUpdateColumnJobCards(item,response.data.jobcards[item]);
            // })
            await Promise.all(
              Object.keys(response?.data?.jobcards).map(async (item) => {
                const formattedData = await getFormattedData(response.data.jobcards[item]);
                handleUpdateColumnJobCards(item, formattedData);
              })
            );
          }
        }
        setLoadings(false);
      })
      .catch((error) => {
        console.log(error);
        setEmptyStateLabel("connectionAPIError")
        setLoadings(false)
      })
  };
  useEffect(() => {
    setColoumnDataJobCards(
      orderManagementSettings?.fetch_balance_quantity?.value
        ? [
          {
            state: "active",
            classname: "pending-for-approval",
            heading: "Active Job Cards",
            jobcards: activeJobcards,
            hasMore: true,
            currentPage: 1,
          },

          {
            state: "under_review",
            classname: "in-production",
            heading: "Under Review Job Cards",
            jobcards: underReviewJobcards,
            hasMore: true,
            currentPage: 1,
          },

          {
            state: "completed",
            classname: "completed-job-cards",
            heading: "Completed Job Cards",
            jobcards: completeCards,
            hasMore: true,
            currentPage: 1,
          },
          {
            state: "cancel",
            classname: "rejected-job-cards",
            heading: "Cancelled Job Cards",
            jobcards: cancelledJobcards,
            hasMore: true,
            currentPage: 1,
          },
        ]
        : [
          {
            state: "pending",
            classname: "pending-for-approval",
            heading: "Pending for approval",
            jobcards: pendingCards,
            hasMore: true,
            currentPage: 1,
          },
          {
            state: "rejected",
            classname: "rejected-job-cards",
            heading: "Rejected Job Cards",
            jobcards: rejectedCards,
            hasMore: true,
            currentPage: 1,
          },
          {
            state: "approved",
            classname: "approved-job-cards",
            heading: "Approved Job Cards",
            jobcards: approvedCards,
            hasMore: true,
            currentPage: 1,
          },
          {
            state: "in_production",
            classname: "in-production",
            heading: "In Production",
            jobcards: inProductionCards,
            hasMore: true,
            currentPage: 1,
          },
          {
            state: "completed",
            classname: "completed-job-cards",
            heading: "Completed Job Cards",
            jobcards: completeCards,
            hasMore: true,
            currentPage: 1,
          },
        ]
    );
  }, [
    pendingCards,
    rejectedCards,
    approvedCards,
    inProductionCards,
    completeCards,
    activeJobcards,
    cancelledJobcards,
    underReviewJobcards,
  ]);

  const columnsHead = [
    {
      title: "Job Card No",
      dataIndex: "jc_code",
      width: "18%",
      align: "left",
      // sorter: {
      //   compare: (a, b) => a.jobcardno - b.jobcardno,
      // },
      // render: (text) => `JC${text}`,
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "12%",
      // sorter: {
      //   compare: (a, b) => a.createddate.localeCompare(b.createddate),
      // },
      render: (text) =>
        `${moment(new Date(text)).format("DD MMM YYYY")}, ${new Date(text).getHours()} : ${new Date(text).getMinutes()}`,
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                `The product specification is in the format of ${format}`
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "16%",
    },
    // {
    //   title: "Number of Orders",
    //   dataIndex: "nooforders",
    //   width: "12%",
    //   align: "center",
    //   // sorter: {
    //   //   compare: (a, b) => a.nooforders - b.nooforders,
    //   // },
    // },
    {
      title: "Trim Loss",
      dataIndex: "trimloss",
      width: "9%",
      render: (text) => (text ? `${text} %` : ""),
    },
    {
      title: "Production Weight",
      dataIndex: "job_card_weight",
      width: '9%',
      render: (text, record) => {
        return `${text} ${unitData ? capitalize(unitData.units_management.weight.default) : 'T'}`
      }
    },
    {
      title: "Paper Machine",
      dataIndex: "machine",
      width: "9%",
    },
    {
      title: "Finishing Process",
      dataIndex: "process",
      width: "12%",
      render: (text) => (<p dangerouslySetInnerHTML={{ __html: text }}></p>)


    },
    {
      title: "Finishing Machine",
      dataIndex: "code",
      width: "9%",
    },
    {
      title: "Created By",
      dataIndex: "createdby",
      width: "10%",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View this job card"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => JobDetailChange(record)}
                disabled={!userDetails.roles.job_cards.view}
              >
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const routeChange = () => {
    navigate("../create-new-job-cards");
  };

  const JobDetailChange = (jobcard) => {
    if (jobcard.type === 'multi_stage') {
      navigate("../job-card-details-multistage", { state: { id: jobcard.jobcardno, jobcardType: jobcard.type } });
      return;
    }
    if (jobcard.machine_type === 'cutter')
      navigate("../sheet-job-card-details", { state: { id: jobcard.jobcardno, type: 'deckle', cutter_type: jobcard.cutter_type, jobcardType: jobcard.type } });
    else
      navigate("../job-card-details", { state: { id: jobcard.jobcardno, jobcardType: jobcard.type } });
  };

  async function getFormattedData(data) {
    return await Promise.all(
      data.map(async (job) => {
        let formattedCode = getJCCode(job.jc_code);
        let body = {
          "bucket_key": job.profile_picture,
          operation: "download"

        }
        let url = job.profile_picture && await getImageURL(body);
        return {
          key: job.uuid,
          jc_code: formattedCode,
          jobcardno: job.jc_id,
          createddate: job.created_date,
          conflictingState: job.conflicting_state,
          is_dummy: job?.is_dummy,
          // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
          //   job.quality ? `${job.quality}` : "-"
          // }/${job.moisture ? job.moisture : '-'}`,
          productspec: job.product_spec,
          grade: job.grade,
          gsm: job.gsm,
          burst_factor: job.burst_factor,
          quality: job.quality,
          nooforders: job.no_of_orders,
          trimloss: job.total_trim_loss_percentage?.toFixed(3),
          machine: job.machine,
          createdby: job.created_by,
          machine_type: job.machine_type,
          code:
            job?.type === "multi_stage"
              ? job?.rewinder_id + " " + (job.cutter_id ? job?.cutter_id : "")
              : job.machine_type === "cutter"
                ? job.cutter_id
                  ? job.cutter_id
                  : "-"
                : job.rewinder_id
                  ? job.rewinder_id
                  : "-",
          name:
            job.machine_type === "cutter"
              ? job.cutter_name
                ? job.cutter_name
                : ""
              : job.rewinder_name
                ? job.rewinder_name
                : "",
          cutter_type:
            job.machine_type === "cutter"
              ? job.cutter_type
                ? job.cutter_type
                : ""
              : "",
          process:
            job?.type === "multi_stage"
              ? "Rewinding and Cutting"
              : job.machine_type === "cutter"
                ? "Cutting <br/>( " +
                (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
                " )"
                : "Rewinding",
          profile_picture: job.profile_picture
            ? url
            : "/static/media/default-pic.921dff75.png",
          type: job?.type,
          job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0
            } `,
          erpState: job.erp_state,
        };
      })
    )
  }

  function handleUpdateColumnJobCards(state, formattedData) {
    switch (state) {
      case "active":
        setActiveJobCards([...formattedData]);
        break;
      case "completed":
        setCompleteCards([...formattedData]);
        break;
      case "cancel":
        setCancelledJobCards([...formattedData]);
        break;
      case "under_review":
        setUnderReviewJobCards([...formattedData]);
        break;
      case "pending":
        setPendingCards([...formattedData]);
        break;
      case "in_production":
        setInProductionCards([...formattedData]);
        break;
      case "approved":
        setApprovedCards([...formattedData]);
        break;
      case "rejected":
        setRejectedCards([...formattedData]);
        break;
      default:
        return;
    }
  }
  // function updateColumnJobCards(response){
  //   console.log(response)
  //     if (orderManagementSettings.fetch_orders_from_erp.value) {
  //       setActiveJobCards(
  //         response.active.map((job) => {
  //           let formattedCode = getJCCode(job.jc_code);
  //           return {
  //             key: job.uuid,
  //             jc_code: formattedCode,
  //             jobcardno: job.jc_id,
  //             createddate: job.created_date,
  //             conflictingState: job.conflicting_state,
  //             is_dummy: job?.is_dummy,
  //             // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //             //   job.quality ? `${job.quality}` : "-"
  //             // }/${job.moisture ? job.moisture : '-'}`,
  //             productspec: job.product_spec,
  //             grade: job.grade,
  //             gsm: job.gsm,
  //             burst_factor: job.burst_factor,
  //             quality: job.quality,
  //             nooforders: job.no_of_orders,
  //             trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //             machine: job.machine,
  //             createdby: job.created_by,
  //             machine_type: job.machine_type,
  //             code:
  //               job?.type === "multi_stage"
  //                 ? job?.rewinder_id +
  //                   " " +
  //                   (job.cutter_id ? job?.cutter_id : "")
  //                 : job.machine_type === "cutter"
  //                 ? job.cutter_id
  //                   ? job.cutter_id
  //                   : "-"
  //                 : job.rewinder_id
  //                 ? job.rewinder_id
  //                 : "-",
  //             name:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_name
  //                   ? job.cutter_name
  //                   : ""
  //                 : job.rewinder_name
  //                 ? job.rewinder_name
  //                 : "",
  //             cutter_type:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_type
  //                   ? job.cutter_type
  //                   : ""
  //                 : "",
  //             process:
  //               job?.type === "multi_stage"
  //                 ? "Rewinding and Cutting"
  //                 : job.machine_type === "cutter"
  //                 ? "Cutting <br/>( " +
  //                   (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
  //                   " )"
  //                 : "Rewinding",
  //             profile_picture: job.profile_picture
  //               ? `${IMAGE_BASE_URL}${job.profile_picture}`
  //               : "/static/media/default-pic.921dff75.png",
  //             type: job?.type,
  //             job_card_weight: `${
  //               job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0
  //             } `,
  //             erpState: job.erp_state,
  //           };
  //         })
  //       );
  //       setCancelledJobCards(
  //         response.cancelled.map((job) => {
  //           let formattedCode = getJCCode(job.jc_code);
  //           return {
  //             key: job.uuid,
  //             jc_code: formattedCode,
  //             conflictingState: job.conflicting_state,
  //             is_dummy: job?.is_dummy,
  //             jobcardno: job.jc_id,
  //             createddate: job.created_date,
  //             // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //             //   job.quality ? `${job.quality}` : "-"
  //             // }/${job.moisture ? job.moisture : '-'}`,
  //             productspec: job.product_spec,
  //             grade: job.grade,
  //             gsm: job.gsm,
  //             burst_factor: job.burst_factor,
  //             quality: job.quality,
  //             nooforders: job.no_of_orders,
  //             trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //             machine: job.machine,
  //             createdby: job.created_by,
  //             machine_type: job.machine_type,
  //             code:
  //               job?.type === "multi_stage"
  //                 ? job?.rewinder_id +
  //                   " " +
  //                   (job.cutter_id ? job?.cutter_id : "")
  //                 : job.machine_type === "cutter"
  //                 ? job.cutter_id
  //                   ? job.cutter_id
  //                   : "-"
  //                 : job.rewinder_id
  //                 ? job.rewinder_id
  //                 : "-",
  //             name:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_name
  //                   ? job.cutter_name
  //                   : ""
  //                 : job.rewinder_name
  //                 ? job.rewinder_name
  //                 : "",
  //             cutter_type:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_type
  //                   ? job.cutter_type
  //                   : ""
  //                 : "",
  //             process:
  //               job?.type === "multi_stage"
  //                 ? "Rewinding and Cutting"
  //                 : job.machine_type === "cutter"
  //                 ? "Cutting <br/>( " +
  //                   (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
  //                   " )"
  //                 : "Rewinding",
  //             profile_picture: job.profile_picture
  //               ? `${IMAGE_BASE_URL}${job.profile_picture}`
  //               : "/static/media/default-pic.921dff75.png",
  //             type: job?.type,
  //             job_card_weight: `${
  //               job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0
  //             } `,
  //             erpState: job.erp_state,
  //           };
  //         })
  //       );
  //       setUnderReviewJobCards(
  //         response.under_review.map((job) => {
  //           let formattedCode = getJCCode(job.jc_code);
  //           return {
  //             key: job.uuid,
  //             jc_code: formattedCode,
  //             conflictingState: job.conflicting_state,
  //             is_dummy: job?.is_dummy,
  //             jobcardno: job.jc_id,
  //             createddate: job.created_date,
  //             // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //             //   job.quality ? `${job.quality}` : "-"
  //             // }/${job.moisture ? job.moisture : '-'}`,
  //             productspec: job.product_spec,
  //             grade: job.grade,
  //             gsm: job.gsm,
  //             burst_factor: job.burst_factor,
  //             quality: job.quality,
  //             nooforders: job.no_of_orders,
  //             trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //             machine: job.machine,
  //             createdby: job.created_by,
  //             machine_type: job.machine_type,
  //             code:
  //               job?.type === "multi_stage"
  //                 ? job?.rewinder_id +
  //                   " " +
  //                   (job.cutter_id ? job?.cutter_id : "")
  //                 : job.machine_type === "cutter"
  //                 ? job.cutter_id
  //                   ? job.cutter_id
  //                   : "-"
  //                 : job.rewinder_id
  //                 ? job.rewinder_id
  //                 : "-",
  //             name:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_name
  //                   ? job.cutter_name
  //                   : ""
  //                 : job.rewinder_name
  //                 ? job.rewinder_name
  //                 : "",
  //             cutter_type:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_type
  //                   ? job.cutter_type
  //                   : ""
  //                 : "",
  //             process:
  //               job?.type === "multi_stage"
  //                 ? "Rewinding and Cutting"
  //                 : job.machine_type === "cutter"
  //                 ? "Cutting <br/>( " +
  //                   (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
  //                   " )"
  //                 : "Rewinding",
  //             profile_picture: job.profile_picture
  //               ? `${IMAGE_BASE_URL}${job.profile_picture}`
  //               : "/static/media/default-pic.921dff75.png",
  //             type: job?.type,
  //             job_card_weight: `${
  //               job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0
  //             } `,
  //             erpState: job.erp_state,
  //           };
  //         })
  //       );
  //     } else {
  //       setPendingCards(
  //         response.pending.map((job) => {
  //           let formattedCode = getJCCode(job.jc_code);
  //           return {
  //             key: job.uuid,
  //             jc_code: formattedCode,
  //             conflictingState: job.conflicting_state,
  //             is_dummy: job?.is_dummy,
  //             jobcardno: job.jc_id,
  //             createddate: job.created_date,
  //             // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //             //   job.quality ? `${job.quality}` : "-"
  //             // }/${job.moisture ? job.moisture : '-'}`,
  //             productspec: job.product_spec,
  //             grade: job.grade,
  //             gsm: job.gsm,
  //             burst_factor: job.burst_factor,
  //             quality: job.quality,
  //             nooforders: job.no_of_orders,
  //             trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //             machine: job.machine,
  //             createdby: job.created_by,
  //             machine_type: job.machine_type,
  //             code:
  //               job?.type === "multi_stage"
  //                 ? job?.rewinder_id +
  //                   " " +
  //                   (job.cutter_id ? job?.cutter_id : "")
  //                 : job.machine_type === "cutter"
  //                 ? job.cutter_id
  //                   ? job.cutter_id
  //                   : "-"
  //                 : job.rewinder_id
  //                 ? job.rewinder_id
  //                 : "-",
  //             name:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_name
  //                   ? job.cutter_name
  //                   : ""
  //                 : job.rewinder_name
  //                 ? job.rewinder_name
  //                 : "",
  //             cutter_type:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_type
  //                   ? job.cutter_type
  //                   : ""
  //                 : "",
  //             process:
  //               job?.type === "multi_stage"
  //                 ? "Rewinding and Cutting"
  //                 : job.machine_type === "cutter"
  //                 ? "Cutting <br/>( " +
  //                   (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
  //                   " )"
  //                 : "Rewinding",
  //             profile_picture: job.profile_picture
  //               ? `${IMAGE_BASE_URL}${job.profile_picture}`
  //               : "/static/media/default-pic.921dff75.png",
  //             type: job?.type,
  //             job_card_weight: `${
  //               job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0
  //             } `,
  //           };
  //         })
  //       );
  //       setRejectedCards(
  //         response.rejected.map((job) => {
  //           let formattedCode = getJCCode(job.jc_code);
  //           return {
  //             key: job.uuid,
  //             jc_code: formattedCode,
  //             conflictingState: job.conflicting_state,
  //             is_dummy: job?.is_dummy,
  //             jobcardno: job.jc_id,
  //             createddate: job.created_date,
  //             // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //             //   job.quality ? `${job.quality}` : "-"
  //             // }/${job.moisture ? job.moisture : '-'}`,
  //             productspec: job.product_spec,
  //             grade: job.grade,
  //             gsm: job.gsm,
  //             burst_factor: job.burst_factor,
  //             quality: job.quality,
  //             nooforders: job.no_of_orders,
  //             trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //             machine: job.machine,
  //             createdby: job.created_by,
  //             machine_type: job.machine_type,
  //             code:
  //               job?.type === "multi_stage"
  //                 ? job?.rewinder_id +
  //                   " " +
  //                   (job.cutter_id ? job?.cutter_id : "")
  //                 : job.machine_type === "cutter"
  //                 ? job.cutter_id
  //                   ? job.cutter_id
  //                   : "-"
  //                 : job.rewinder_id
  //                 ? job.rewinder_id
  //                 : "-",
  //             name:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_name
  //                   ? job.cutter_name
  //                   : ""
  //                 : job.rewinder_name
  //                 ? job.rewinder_name
  //                 : "",
  //             cutter_type:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_type
  //                   ? job.cutter_type
  //                   : ""
  //                 : "",
  //             process:
  //               job?.type === "multi_stage"
  //                 ? "Rewinding and Cutting"
  //                 : job.machine_type === "cutter"
  //                 ? "Cutting <br/>( " +
  //                   (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
  //                   " )"
  //                 : "Rewinding",
  //             profile_picture: job.profile_picture
  //               ? `${IMAGE_BASE_URL}${job.profile_picture}`
  //               : "/static/media/default-pic.921dff75.png",
  //             type: job?.type,
  //             job_card_weight: `${
  //               job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0
  //             } `,
  //           };
  //         })
  //       );
  //       setApprovedCards(
  //         response.approved.map((job) => {
  //           let formattedCode = getJCCode(job.jc_code);
  //           return {
  //             key: job.uuid,
  //             jc_code: formattedCode,
  //             jobcardno: job.jc_id,
  //             conflictingState: job.conflicting_state,
  //             is_dummy: job?.is_dummy,

  //             createddate: job.created_date,
  //             // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //             //   job.quality ? `${job.quality}` : "-"
  //             // }/${job.moisture ? job.moisture : '-'}`,
  //             productspec: job.product_spec,
  //             grade: job.grade,
  //             gsm: job.gsm,
  //             burst_factor: job.burst_factor,
  //             quality: job.quality,
  //             nooforders: job.no_of_orders,
  //             trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //             machine: job.machine,
  //             createdby: job.created_by,
  //             machine_type: job.machine_type,
  //             code:
  //               job?.type === "multi_stage"
  //                 ? job?.rewinder_id +
  //                   " " +
  //                   (job.cutter_id ? job?.cutter_id : "")
  //                 : job.machine_type === "cutter"
  //                 ? job.cutter_id
  //                   ? job.cutter_id
  //                   : "-"
  //                 : job.rewinder_id
  //                 ? job.rewinder_id
  //                 : "-",
  //             name:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_name
  //                   ? job.cutter_name
  //                   : ""
  //                 : job.rewinder_name
  //                 ? job.rewinder_name
  //                 : "",
  //             cutter_type:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_type
  //                   ? job.cutter_type
  //                   : ""
  //                 : "",
  //             process:
  //               job?.type === "multi_stage"
  //                 ? "Rewinding and Cutting"
  //                 : job.machine_type === "cutter"
  //                 ? "Cutting <br/>( " +
  //                   (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
  //                   " )"
  //                 : "Rewinding",
  //             profile_picture: job.profile_picture
  //               ? `${IMAGE_BASE_URL}${job.profile_picture}`
  //               : "/static/media/default-pic.921dff75.png",
  //             type: job?.type,
  //             job_card_weight: `${
  //               job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0
  //             } `,
  //           };
  //         })
  //       );
  //       setInProductionCards(
  //         response.in_production.map((job) => {
  //           let formattedCode = getJCCode(job.jc_code);
  //           return {
  //             key: job.uuid,
  //             jc_code: formattedCode,
  //             jobcardno: job.jc_id,
  //             createddate: job.created_date,
  //             conflictingState: job.conflicting_state,
  //             is_dummy: job?.is_dummy,

  //             // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //             //   job.quality ? `${job.quality}` : "-"
  //             // }/${job.moisture ? job.moisture : '-'}`,
  //             productspec: job.product_spec,
  //             grade: job.grade,
  //             gsm: job.gsm,
  //             burst_factor: job.burst_factor,
  //             quality: job.quality,
  //             nooforders: job.no_of_orders,
  //             trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //             machine: job.machine,
  //             createdby: job.created_by,
  //             machine_type: job.machine_type,
  //             code:
  //               job?.type === "multi_stage"
  //                 ? job?.rewinder_id +
  //                   " " +
  //                   (job.cutter_id ? job?.cutter_id : "")
  //                 : job.machine_type === "cutter"
  //                 ? job.cutter_id
  //                   ? job.cutter_id
  //                   : "-"
  //                 : job.rewinder_id
  //                 ? job.rewinder_id
  //                 : "-",
  //             name:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_name
  //                   ? job.cutter_name
  //                   : ""
  //                 : job.rewinder_name
  //                 ? job.rewinder_name
  //                 : "",
  //             cutter_type:
  //               job.machine_type === "cutter"
  //                 ? job.cutter_type
  //                   ? job.cutter_type
  //                   : ""
  //                 : "",
  //             process:
  //               job?.type === "multi_stage"
  //                 ? "Rewinding and Cutting"
  //                 : job.machine_type === "cutter"
  //                 ? "Cutting <br/>( " +
  //                   (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
  //                   " )"
  //                 : "Rewinding",
  //             profile_picture: job.profile_picture
  //               ? `${IMAGE_BASE_URL}${job.profile_picture}`
  //               : "/static/media/default-pic.921dff75.png",
  //             type: job?.type,
  //             job_card_weight: `${
  //               job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0
  //             } `,
  //           };
  //         })
  //       );
  //     }
  //     setCompleteCards(
  //       response.completed.map((job) => {
  //         let formattedCode = getJCCode(job.jc_code);
  //         return {
  //           key: job.uuid,
  //           jc_code: formattedCode,
  //           conflictingState: job?.conflicting_state,
  //           is_dummy: job?.is_dummy,
  //           jobcardno: job.jc_id,
  //           createddate: job.created_date,
  //           // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //           //   job.quality ? `${job.quality}` : "-"
  //           // }/${job.moisture ? job.moisture : '-'}`,
  //           productspec: job.product_spec,
  //           grade: job.grade,
  //           gsm: job.gsm,
  //           burst_factor: job.burst_factor,
  //           quality: job.quality,
  //           nooforders: job.no_of_orders,
  //           trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //           machine: job.machine,
  //           createdby: job.created_by,
  //           machine_type: job.machine_type,
  //           code:
  //             job?.type === "multi_stage"
  //               ? job?.rewinder_id + " " + (job.cutter_id ? job?.cutter_id : "")
  //               : job.machine_type === "cutter"
  //               ? job.cutter_id
  //                 ? job.cutter_id
  //                 : "-"
  //               : job.rewinder_id
  //               ? job.rewinder_id
  //               : "-",
  //           name:
  //             job.machine_type === "cutter"
  //               ? job.cutter_name
  //                 ? job.cutter_name
  //                 : ""
  //               : job.rewinder_name
  //               ? job.rewinder_name
  //               : "",
  //           cutter_type:
  //             job.machine_type === "cutter"
  //               ? job.cutter_type
  //                 ? job.cutter_type
  //                 : ""
  //               : "",
  //           process:
  //             job?.type === "multi_stage"
  //               ? "Rewinding and Cutting"
  //               : job.machine_type === "cutter"
  //               ? "Cutting <br/>( " +
  //                 (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
  //                 " )"
  //               : "Rewinding",
  //           profile_picture: job.profile_picture
  //             ? `${IMAGE_BASE_URL}${job.profile_picture}`
  //             : "/static/media/default-pic.921dff75.png",
  //           type: job?.type,
  //           job_card_weight: `${
  //             job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0
  //           } `,
  //           erpState: job?.erp_state,
  //         };
  //       })
  //     );
  // }

  //api-call to get details of all the job cards
  // const getAllJobCards = (params) => {
  //   getJobCardsInfo(params)
  //     .then((response) => {
  //       if(response.total_jobcards == 0)
  //         {
  //           setEmptyStateLabel("noData");

  //         }
  //         else{
  //               setEmptyStateLabel();
  //         }
  //                  if(orderManagementSettings?.fetch_orders_from_erp?.value){
  //       setActiveJobCards(
  //       response.active.map((job) => {
  //       let formattedCode = getJCCode(job.jc_code);
  //       return {
  //         key: job.uuid,
  //         jc_code: formattedCode,
  //         jobcardno: job.jc_id,
  //         createddate: job.created_date,
  //         conflictingState: job.conflicting_state,
  //         is_dummy: job?.is_dummy,
  //         // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //         //   job.quality ? `${job.quality}` : "-"
  //         // }/${job.moisture ? job.moisture : '-'}`,
  //         productspec: job.product_spec,
  //         grade: job.grade,
  //         gsm: job.gsm,
  //         burst_factor: job.burst_factor,
  //         quality: job.quality,
  //         nooforders: job.no_of_orders,
  //         trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //         machine: job.machine,
  //         createdby: job.created_by,
  //         machine_type : job.machine_type,
  //         code : job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
  //         name : job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
  //         cutter_type : job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
  //         process : job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
  //         profile_picture: job.profile_picture ? `${IMAGE_BASE_URL}${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
  //         type: job?.type,
  //         job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0} `,
  //         erpState: job.erp_state
  //       };
  //     })
  //   )
  //   setCancelledJobCards(
  //     response.cancel.map((job) => {
  //       let formattedCode = getJCCode(job.jc_code);
  //       return {
  //         key: job.uuid,
  //         jc_code: formattedCode,
  //         conflictingState: job.conflicting_state,
  //         is_dummy: job?.is_dummy,
  //         jobcardno: job.jc_id,
  //         createddate: job.created_date,
  //         // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //         //   job.quality ? `${job.quality}` : "-"
  //         // }/${job.moisture ? job.moisture : '-'}`,
  //         productspec: job.product_spec,
  //         grade: job.grade,
  //         gsm: job.gsm,
  //         burst_factor: job.burst_factor,
  //         quality: job.quality,
  //         nooforders: job.no_of_orders,
  //         trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //         machine: job.machine,
  //         createdby: job.created_by,
  //         machine_type : job.machine_type,
  //         code : job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
  //         name : job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
  //         cutter_type : job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
  //         process : job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
  //         profile_picture: job.profile_picture ? `${IMAGE_BASE_URL}${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
  //         type: job?.type,
  //         job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0} `,
  //         erpState: job.erp_state

  //       };
  //     })
  //   )
  //   setUnderReviewJobCards(
  //     response.under_review.map((job) => {
  //       let formattedCode = getJCCode(job.jc_code);
  //       return {
  //         key: job.uuid,
  //         jc_code: formattedCode,
  //         conflictingState: job.conflicting_state,
  //         is_dummy: job?.is_dummy,
  //         jobcardno: job.jc_id,
  //         createddate: job.created_date,
  //         // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //         //   job.quality ? `${job.quality}` : "-"
  //         // }/${job.moisture ? job.moisture : '-'}`,
  //         productspec: job.product_spec,
  //         grade: job.grade,
  //         gsm: job.gsm,
  //         burst_factor: job.burst_factor,
  //         quality: job.quality,
  //         nooforders: job.no_of_orders,
  //         trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //         machine: job.machine,
  //         createdby: job.created_by,
  //         machine_type : job.machine_type,
  //         code : job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
  //         name : job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
  //         cutter_type : job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
  //         process : job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
  //         profile_picture: job.profile_picture ? `${IMAGE_BASE_URL}${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
  //         type: job?.type,
  //         job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0} `,
  //         erpState: job.erp_state
  //       };
  //     })
  //   )

  //  }
  //  else{ 
  //   setPendingCards(
  //     response.pending.map((job) => {
  //       let formattedCode = getJCCode(job.jc_code);
  //       return {
  //         key: job.uuid,
  //         jc_code: formattedCode,
  //         conflictingState: job.conflicting_state,
  //         is_dummy: job?.is_dummy,
  //         jobcardno: job.jc_id,
  //         createddate: job.created_date,
  //         // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //         //   job.quality ? `${job.quality}` : "-"
  //         // }/${job.moisture ? job.moisture : '-'}`,
  //         productspec: job.product_spec,
  //         grade: job.grade,
  //         gsm: job.gsm,
  //         burst_factor: job.burst_factor,
  //         quality: job.quality,
  //         nooforders: job.no_of_orders,
  //         trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //         machine: job.machine,
  //         createdby: job.created_by,
  //         machine_type : job.machine_type,
  //         code : job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
  //         name : job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
  //         cutter_type : job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
  //         process : job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
  //         profile_picture: job.profile_picture ? `${IMAGE_BASE_URL}${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
  //         type: job?.type,
  //         job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0} `

  //       };
  //     })
  //   );
  //   setRejectedCards(
  //     response.rejected.map((job) => {
  //       let formattedCode = getJCCode(job.jc_code);
  //       return {
  //         key: job.uuid,
  //         jc_code: formattedCode,
  //         conflictingState: job.conflicting_state,
  //         is_dummy: job?.is_dummy,
  //         jobcardno: job.jc_id,
  //         createddate: job.created_date,
  //         // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //         //   job.quality ? `${job.quality}` : "-"
  //         // }/${job.moisture ? job.moisture : '-'}`,
  //         productspec: job.product_spec,
  //         grade: job.grade,
  //         gsm: job.gsm,
  //         burst_factor: job.burst_factor,
  //         quality: job.quality,
  //         nooforders: job.no_of_orders,
  //         trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //         machine: job.machine,
  //         createdby: job.created_by,
  //         machine_type : job.machine_type,
  //         code : job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
  //         name : job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
  //         cutter_type : job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
  //         process : job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
  //         profile_picture: job.profile_picture ? `${IMAGE_BASE_URL}${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
  //         type: job?.type,
  //         job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0} `

  //       };
  //     })
  //   );
  //   setApprovedCards(
  //     response.approved.map((job) => {
  //       let formattedCode = getJCCode(job.jc_code);
  //       return {
  //         key: job.uuid,
  //         jc_code: formattedCode,
  //         jobcardno: job.jc_id,
  //         conflictingState: job.conflicting_state,
  //         is_dummy: job?.is_dummy,

  //         createddate: job.created_date,
  //         // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //         //   job.quality ? `${job.quality}` : "-"
  //         // }/${job.moisture ? job.moisture : '-'}`,
  //         productspec: job.product_spec,
  //         grade: job.grade,
  //         gsm: job.gsm,
  //         burst_factor: job.burst_factor,
  //         quality: job.quality,
  //         nooforders: job.no_of_orders,
  //         trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //         machine: job.machine,
  //         createdby: job.created_by,
  //         machine_type : job.machine_type,
  //         code : job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
  //         name : job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
  //         cutter_type : job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
  //         process : job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
  //         profile_picture: job.profile_picture ? `${IMAGE_BASE_URL}${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
  //         type: job?.type,
  //         job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0} `


  //       };
  //     })
  //   );
  //   setInProductionCards(
  //     response.in_production.map((job) => {
  //       let formattedCode = getJCCode(job.jc_code);
  //       return {
  //         key: job.uuid,
  //         jc_code: formattedCode,
  //         jobcardno: job.jc_id,
  //         createddate: job.created_date,
  //         conflictingState: job.conflicting_state,
  //         is_dummy: job?.is_dummy,

  //         // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //         //   job.quality ? `${job.quality}` : "-"
  //         // }/${job.moisture ? job.moisture : '-'}`,
  //         productspec: job.product_spec,
  //         grade: job.grade,
  //         gsm: job.gsm,
  //         burst_factor: job.burst_factor,
  //         quality: job.quality,
  //         nooforders: job.no_of_orders,
  //         trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //         machine: job.machine,
  //         createdby: job.created_by,
  //         machine_type : job.machine_type,
  //         code : job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
  //         name : job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
  //         cutter_type : job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
  //         process : job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
  //         profile_picture: job.profile_picture ? `${IMAGE_BASE_URL}${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
  //         type: job?.type,
  //         job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0} `


  //       };
  //     })
  //   )
  // }
  //   setCompleteCards(
  //     response.completed.map((job) => {
  //       let formattedCode = getJCCode(job.jc_code);
  //       return {
  //         key: job.uuid,
  //         jc_code: formattedCode,
  //         conflictingState: job?.conflicting_state,
  //         is_dummy: job?.is_dummy,
  //         jobcardno: job.jc_id,
  //         createddate: job.created_date,
  //         // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
  //         //   job.quality ? `${job.quality}` : "-"
  //         // }/${job.moisture ? job.moisture : '-'}`,
  //         productspec: job.product_spec,
  //         grade: job.grade,
  //         gsm: job.gsm,
  //         burst_factor: job.burst_factor,
  //         quality: job.quality,
  //         nooforders: job.no_of_orders,
  //         trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //         machine: job.machine,
  //         createdby: job.created_by,
  //         machine_type : job.machine_type,
  //         code : job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
  //         name : job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
  //         cutter_type : job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
  //         process : job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
  //         profile_picture: job.profile_picture ? `${IMAGE_BASE_URL}${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
  //         type: job?.type,
  //         job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0} `,
  //         erpState: job?.erp_state

  //       };
  //     })
  //   );
  //       setLoadings(false)
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const getTabledata = () =>
    jobCardsList.map((job) => {
      let formattedCode = getJCCode(job.jc_code);
      return {
        key: job.uuid,
        jc_code: formattedCode,
        jobcardno: job.jc_id,
        createddate: job.created_date,
        // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
        //   job.quality ? `${job.quality}` : "-"
        // }/${job.moisture ? job.moisture : '-'}`,
        productspec: job.product_spec,
        grade: job.grade,
        gsm: job.gsm,
        burst_factor: job.burst_factor,
        quality: job.quality,
        nooforders: job.no_of_orders,
        trimloss: job.total_trim_loss_percentage?.toFixed(3),
        machine: job.machine,
        createdby: job.created_by,
        machine_type: job.machine_type,
        code: job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id ? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
        name: job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
        cutter_type: job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
        process: job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
        profile_picture: job.profile_picture ? `${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
        type: job?.type,
        job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0} `
      };
    });

  // const stateScrollHandler = (selectedState) => {
  //   const temp = [...coloumnDataJobCards];
  //   //incrementing page number for a state
  //   for (let i = 0; i < temp.length; i++) {
  //     if (temp[i].state === selectedState) {
  //       temp[i].currentPage = temp[i].currentPage + 1;
  //     }
  //   }
  //   setColoumnDataJobCards([...temp]);
  //   //adding jobcards
  //   const reqPage = temp.filter((item) => item.state === selectedState);
  //   getJobCardsInfo(
  //     { page: reqPage[0].currentPage, size: 10 },
  //     selectedState
  //   ).then((resp) => {
  //     const tempState = [...coloumnDataJobCards];
  //     for (let i = 0; i < tempState.length; i++) {
  //       if (tempState[i].state === selectedState) {
  //         tempState[i].jobcards = tempState[i].jobcards.concat(
  //           resp[selectedState].map((job) => {
  //             let formattedCode = getJCCode(job.jc_code);
  //             return {
  //               key: job.uuid,
  //               jc_code: formattedCode,
  //               jobcardno: job.jc_id,
  //               createddate: job.created_date,
  //               conflictingState : job?.conflicting_state,
  //               is_dummy: job?.is_dummy,
  //               erpState: job?.erp_state,

  //               // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : "-"}/${
  //               //   job.quality ? `${job.quality}` : "-"
  //               // }/${job.moisture ? job.moisture : '-'}`,
  //               productspec: job.product_spec,
  //               grade: job.grade,
  //               gsm: job.gsm,
  //               burst_factor: job.burst_factor,
  //               quality: job.quality,
  //               nooforders: job.no_of_orders,
  //               trimloss: job.total_trim_loss_percentage?.toFixed(3),
  //               machine: job.machine,
  //               createdby: job.created_by,
  //               machine_type : job.machine_type,
  //               code : job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
  //               name : job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
  //               cutter_type : job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
  //               process : job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
  //               profile_picture: job.profile_picture ? `${IMAGE_BASE_URL}${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
  //               type: job?.type,
  //               job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0} `

  //             };
  //           })
  //         );
  //         if (tempState[i].jobcards.length >= resp.total_jobcards) {
  //           tempState[i].hasMore = false;
  //         }
  //       }
  //     }
  //     setColoumnDataJobCards([...tempState]);
  //   });
  // };

  const stateScrollHandler = (selectedState) => {
    const temp = [...coloumnDataJobCards];
    //incrementing page number for a state
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].state === selectedState) {
        temp[i].currentPage = temp[i].currentPage + 1;
      }
    }
    setColoumnDataJobCards([...temp]);
    //adding jobcards
    const reqPage = temp.filter((item) => item.state === selectedState);
    const filter = appliedFilters.length > 0 ? appliedFilters : storedAppliedFilters;
    getFilteredJobcards({ page: reqPage[0]?.currentPage, size: 10 }, filter, selectedState, searchValue)
      .then(async (response) => {
        const resp = response.data;
        const tempState = [...coloumnDataJobCards];
        for (let i = 0; i < tempState.length; i++) {
          if (tempState[i].state === selectedState) {
            const formattedData = await getFormattedData(resp[selectedState])
            tempState[i].jobcards = tempState[i].jobcards.concat(formattedData
              // resp[selectedState].map((job) => {
              //   let formattedCode = getJCCode(job.jc_code);
              //   return {
              //     key: job.uuid,
              //     jc_code: formattedCode,
              //     jobcardno: job.jc_id,
              //     createddate: job.created_date,
              //     conflictingState : job?.conflicting_state,
              //     is_dummy: job?.is_dummy,
              //     erpState: job?.erp_state,

              //     // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : "-"}/${
              //     //   job.quality ? `${job.quality}` : "-"
              //     // }/${job.moisture ? job.moisture : '-'}`,
              //     productspec: job.product_spec,
              //     grade: job.grade,
              //     gsm: job.gsm,
              //     burst_factor: job.burst_factor,
              //     quality: job.quality,
              //     nooforders: job.no_of_orders,
              //     trimloss: job.total_trim_loss_percentage?.toFixed(3),
              //     machine: job.machine,
              //     createdby: job.created_by,
              //     machine_type : job.machine_type,
              //     code : job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
              //     name : job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
              //     cutter_type : job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
              //     process : job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
              //     profile_picture: job.profile_picture ? `${IMAGE_BASE_URL}${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
              //     type: job?.type,
              //     job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0} `

              //   };
              // })
            );
            if (tempState[i].jobcards.length >= resp.total_jobcards) {
              tempState[i].hasMore = false;
            }
          }
        }
        setColoumnDataJobCards([...tempState]);
      });
  };

  const scrollHandler = (selectedColumn) => {
    switch (selectedColumn.state) {
      case "pending":
        stateScrollHandler("pending");
        break;
      case "approved":
        stateScrollHandler("approved");
        break;
      case "rejected":
        stateScrollHandler("rejected");
        break;
      case "in_production":
        stateScrollHandler("in_production");
        break;
      case "completed":
        stateScrollHandler("completed")
        break
      case "active":
        stateScrollHandler("active")
        break
      case 'under_review':
        stateScrollHandler('under_review')
        break
      case 'cancel':
        stateScrollHandler('cancel')
        break;
      default: {
      }
    }
  };

  const searchOrders = async (value = "") => {
    setSearchValue(value);
    // if (value === "" || value === null) {
    //       setEmptyStateLabel();
    //   fetchJobCardsList(paginationParams, tableJobCardState);
    // } else {
    //   setClearSearch(false);
    //   searchJobCardByJobcardNo(value)
    //     .then((response) => {
    //       setEmptyStateLabel("search");
    //       setTotalRecords(response.data[tableJobCardState].length);
    //       setJobCardsList(response.data[tableJobCardState]);
    //     })
    //     .catch((error) =>
    //       console.log("Error in search of jobcard records:", error),
    //       setEmptyStateLabel("connectionAPIError")
    //     );
    // }
  };

  const handleDropdownClick = async (record, key) => {

    try {
      switch (key) {
        case 'sendForReview': // sendForReview
          const response1 = await changeProductionJobCardState({
            id: record.details.jobcardno,
            state: "under_review",
          });
          // setUnderReviewJobCards([...underReviewJobcards, record]);
          // setGridView(true);
          // getAllJobCards({ page: 1, size: 10 });
          fetchFilteredJobCards();

          break;

        case 'markCancelled': // markCancelled
          const response2 = await changeProductionJobCardState({
            id: record.details.jobcardno,
            state: "cancel",
          });
          // setCancelledJobCards([...cancelledJobcards, record]);
          // setGridView(true);
          // getAllJobCards({ page: 1, size: 10 });
          fetchFilteredJobCards();


          break;

        case 'markCompleted': // markCompleted
          const response3 = await changeProductionJobCardState({
            id: record.details.jobcardno,
            state: "complete",
          });
          // setCompleteCards([...completeCards, record]);
          // setGridView(true);
          // getAllJobCards({ page: 1, size: 10 });
          fetchFilteredJobCards();


          break;

        default:
          console.warn("Unknown dropdown key:", key);
      }
    } catch (error) {
      console.error("Error handling dropdown click:", error);
    }
  };


  // const handleScroll = () => {
  //   const scrollContainer = scrollContainerRef.current;
  //   const scrollTop = scrollContainer.scrollTop;
  //   const scrollHeight = scrollContainer.scrollHeight;
  //   const clientHeight = scrollContainer.clientHeight;

  //   // If scrolled to half of the height
  //   if (scrollTop + clientHeight >= scrollHeight / 2) {
  //     scrollHandler();
  //   }
  // };

  // useEffect(() => {
  //   if(scrollContainerRef.current)
  //   {
  //   const scrollContainer = scrollContainerRef.current;
  //   scrollContainer.addEventListener('scroll', handleScroll);

  //   return () => {
  //     scrollContainer.removeEventListener('scroll', handleScroll);
  //   };
  // }
  // }, [scrollContainerRef.current]);

  // useEffect(() => {
  //   if(scrollContainerRef.current)
  //   {
  //   const container = scrollContainerRef.current;
  //   const handleScroll = () => {
  //     const { scrollTop, scrollHeight, clientHeight } = container;
  //     if (scrollTop + clientHeight >= scrollHeight / 2) {
  //       scrollHandler();
  //     }
  //   };
  //   container.addEventListener('scroll', handleScroll);
  //   return () => container.removeEventListener('scroll', handleScroll);
  // }
  // }, [scrollContainerRef.current]);

  // useEffect(() => {
  //   if(!orderManagementSettings){
  //     return;
  //   }
  //   if(!gridView){
  //     fetchJobCardsList(paginationParams, tableJobCardState);
  //   } else{
  //     getAllJobCards({ page: 1, size: 10 });

  //   }
  // }, [gridView, orderManagementSettings]);

  // useEffect(() => {
  //   if (!appliedFilters.length)
  //     fetchJobCardsList(paginationParams, tableJobCardState);
  // }, [tableJobCardState, paginationParams]);

  // useEffect(() => {
  //   if(!gridView)
  //   {
  //   if (appliedFilters.length) {
  //     fetchFilteredJobCards();
  //   } else {
  //         setEmptyStateLabel();
  //     fetchJobCardsList(paginationParams, tableJobCardState);
  //   }
  // }
  // }, [appliedFilters, paginationParams, tableJobCardState]);

  useEffect(() => {
    setTableData(jobCardsList ? getTabledata() : []);

  }, [jobCardsList]);


  const handlePriorityAction = () => {
    navigate("../create-new-job-cards");
  };

  //Card component to display the job card
  const Cards = (props) => {
    return (
      <Card
        hoverable={true}
        //for card border
        bodyStyle={{
          borderRadius: "5px",
          ...(props.details.conflictingState != "non_conflicting" && {
            border: "2px solid var(--theme-color)",
          }),
        }}
        onClick={() =>
          // userDetails.roles.job_cards.view &&
          (userDetails?.roles?.approve_jobcards.view ||
            userDetails?.roles?.job_cards.view ||
            userDetails?.roles?.job_cards.edit ||
            userDetails?.role_type == "ADMIN" ||
            userDetails?.role_type == "SUPER_ADMIN") &&
          JobDetailChange(props.details)
        }
      >
        <div className="jbCardHeader">
          {props.details.jc_code?.length > 10 ? (
            <Tooltip placement="bottomLeft" title={props.details.jc_code}>
              {/* key condition if its in conflicting state */}
              {props.details.conflictingState != "non_conflicting" && (
                <span>
                  <Iconmoon icon="warning-icon" size={14} color="#EA655B" />
                </span>
              )}
              <h5
                style={{
                  marginLeft:
                    props.conflictingState !== "non_conflicting"
                      ? "0px"
                      : props.details?.type === "multi_stage"
                        ? "-11px"
                        : "-28px",
                  // color: "var(--theme-color)"
                }}
              >
                {props?.details?.jc_code?.slice(0, 11) + "..."}
              </h5>
              {/* <h5>{props?.details?.jc_code?.slice(0,11)+"..."}</h5> */}
            </Tooltip>
          ) : (
            //key condition if its in conflicting state
            <>

              <h5
                style={{
                  marginLeft: !props.conflictingState
                    ? "0px"
                    : props.details?.type === "multi_stage"
                      ? "-58px"
                      : "-78px",
                  color: props.details.conflictingState === "non_conflicting" ? "" : "var(--theme-color)",
                  display: "flex",
                }}
              >
                {props.details.conflictingState != "non_conflicting" && (
                  <span>
                    <Iconmoon icon="warning-icon" size={14} color="#EA655B" />
                  </span>
                )}
                {/* Dummy jc */}
                {props.details.is_dummy && (
                  <span>
                    <Iconmoon icon="dummy_orders" size={14} color="#EA655B" />
                  </span>
                )}
                {props.details.jc_code}
              </h5>
            </>
          )}
          <span>
            <img src={machineIcon} alt="" style={{ width: "14px" }} />
            &nbsp;{""} &nbsp;
            {/* &nbsp;{" - "} &nbsp; */}
            {/* {props.details?.type === 'multi_stage' ? <><Iconmoon icon="tissue-role" size={14} color="#EA655B" />&nbsp;{" - "} &nbsp; <Iconmoon icon="sheet" size={16} color="#EA655B" /></> : <Iconmoon icon={props.details.machine_type === 'rewinder' ? "tissue-role" : "sheet"} size={14} color="#EA655B" /> } */}
            {/* alrdery commented  
            {props.details.machine}{`${props.details.code !== '-'?'-'+props.details.code :'' }`} */}
            {props.details?.type === "multi_stage" ? (
              <>
                <Iconmoon icon="tissue-role" size={14} color="#EA655B" />
                {""}
                <Iconmoon icon="sheet" size={16} color="#EA655B" />
              </>
            ) : (
              <Iconmoon
                icon={
                  props.details.machine_type === "rewinder"
                    ? "tissue-role"
                    : "sheet"
                }
                size={14}
                color="#EA655B"
              />
            )}
            {orderManagementSettings?.fetch_balance_quantity?.value && <div className="actionBtn">
              <Dropdown
                overlay={
                  <Menu>
                    {(props.details.erpState === "active" ||
                      props.details.erpState === "cancel" ||
                      props.details.erpState === "complete") && (
                        <Menu.Item key="1" style={{ padding: "0px 6px" }}>
                          <Button
                            className="themeBtn noBg"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDropdownClick(props, "sendForReview");
                            }}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                          >
                            Send for Review
                          </Button>
                        </Menu.Item>
                      )}
                    {(props.details.erpState === "active" ||
                      props.details.erpState === "under_review") && (
                        <Menu.Item key="2" style={{ padding: "0px 6px" }}>
                          <Button
                            // ... other styles
                            className="themeBtn noBg"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDropdownClick(props, "markCancelled");
                            }}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                          >
                            Mark Cancelled
                          </Button>
                        </Menu.Item>
                      )}
                    {(props.details.erpState === "active" ||
                      props.details.erpState === "under_review") && (
                        <Menu.Item key="3" style={{ padding: "0px 6px" }}>
                          <Button
                            // ... other styles
                            className="themeBtn noBg"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDropdownClick(props, "markCompleted");
                            }}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                          >
                            Mark Completed
                          </Button>
                        </Menu.Item>
                      )}
                  </Menu>
                }
                placement="bottom"
                arrow
              >
                <DisabledButtonStyle>
                  <Button>
                    <Iconmoon icon="3dot-menu" size={14} color="#605E5C" />
                  </Button>
                </DisabledButtonStyle>
              </Dropdown>
            </div>}
          </span>
        </div>
        <div className="jbCardBody">
          <ul>
            <li>
              Grade: {props.details.grade} / {props.details.quality}
            </li>
            <li>
              GSM: {props.details.gsm}, BF: {props.details.burst_factor}
            </li>
            <li>
              Trim Loss: {parseFloat(props.details.trimloss)?.toFixed(2)}%,
              Prod. Wt:{" "}
              {parseFloat(props?.details?.job_card_weight)?.toFixed(1)}{" "}
              {unitData
                ? capitalize(unitData.units_management.weight.default)
                : "T"}{" "}
            </li>
          </ul>
        </div>
        <div className="jbCardFooter">
          <Tooltip placement="bottomLeft" title={props.details.createdby}>
            <div className="jbCreater">
              <img src={props.details.profile_picture} alt="user profile" />
            </div>
          </Tooltip>
          <div className="jbdata">
            <span className="date">
              {moment(new Date(props.details.createddate)).format("DD MMM YY")}
            </span>
            <span className="time">
              {`${new Date(props.details.createddate)
                .getHours()
                .toString()
                .padStart(2, "0")} : ${new Date(props.details.createddate)
                  .getMinutes()
                  .toString()
                  .padStart(2, "0")} `}
            </span>
          </div>
        </div>
      </Card>
    );
  };

  //Column component to display the job cards inside the different states.
  const JobCardColoumns = (props) => {
    return (
      <JobListColumn>
        <div className="jobListWrap">
          <JobCardHeader className={props.classname}>
            <h4>{props.heading}</h4>
          </JobCardHeader>
          {/* <SimpleBar className="cardRollers"> */}
          <div
            id={`scrollableDiv - ${props.state}`}
            style={{ height: 950, overflow: "auto" }}
          >
            <InfiniteScroll
              dataLength={props.jobcards.length}
              next={() => props.scrollHandler(props)}
              hasMore={props.hasMore}
              scrollableTarget={`scrollableDiv - ${props.state}`}
              loader={<h4>Loading...</h4>}
            >
              {props.jobcards.map((data) => {
                return <Cards details={data} />;
              })}
            </InfiniteScroll>
          </div>
          {/* </SimpleBar> */}
        </div>
      </JobListColumn>
    );
  };



  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel) {
      if (emptyStateLabel === "noData") {
        propsData["label"] = emptyStateLabel;
        propsData["heading"] = "No records in this list";
        propsData["subHeading"] = "There are no records to show in this list. Add your first record to view details here";
      } else if (emptyStateLabel === "search") {
        propsData["label"] = emptyStateLabel;
        propsData["heading"] = "No records found";
        propsData["subHeading"] = "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
      } else if (emptyStateLabel === "filter") {
        propsData["label"] = emptyStateLabel;
        propsData["heading"] = "No records found";
        propsData["subHeading"] = "There is no record matching your filter. Try changing your filter to find what you are looking for.";
      } else {
        propsData["label"] = emptyStateLabel;
        propsData["heading"] = "Something went wrong";
        propsData["subHeading"] = "Check your internet connection or try reloading the page.";
      }
      setEmptyStatePropsData(propsData);
    }
    else {
      setEmptyStatePropsData();
    }
  }, [emptyStateLabel]);

  const refresh = () => {
    // if(!gridView){
    //   fetchJobCardsList(paginationParams, tableJobCardState);
    // } else{
    //   getAllJobCards({ page: 1, size: 10 });

    // }
    fetchFilteredJobCards();
  }

  return orderManagementSettings &&
    deckleManagementSettings &&
    pendingCards &&
    rejectedCards &&
    approvedCards &&
    inProductionCards &&
    completeCards ? (
    <RightLayoutContainer id="right-layout-container">
      <PageTitleComp ref={titleRef} style={{ borderBottom: !gridView && "0", position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff" }}>
        <TableList className="job-switch">
          <div className="radioSwitchStyle" style={{ zIndex: 10 }}>
            <div className="table-view">
              <HaberForm>
                <RadioButtonStyle>
                  <div
                    className="boxFormType switchRadio"
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    <Radio.Group
                      options={gridViewData}
                      onChange={handleViewChange}
                      value={gridView}
                      optionType="button"
                      buttonStyle="solid"
                      className={gridView ? "gridViewActive" : "ListViewActive"}
                    />
                  </div>
                </RadioButtonStyle>
              </HaberForm>
            </div>
          </div>
        </TableList>
        <PageHeader
          ghost={false}
          title="Job Cards"
          extra={[
            <Button
              key="2"
              className="themeBtn"
              onClick={routeChange}
              disabled={!userDetails.roles.job_cards.edit}
            >
              <Iconmoon icon="edit" size={14} color="#ffffff" />
              Create a new Job Card
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      {orderManagementSettings &&
        (gridView ? (
          <JobCardContainer>
            <div className="jobGutter">
              <div className="cardMainGroup">
                {!loadings && (
                  <SearchContainer
                    placeholder={"Search JobCard No"}
                    fetchOrder={searchOrders}
                    clearSearch={clearSearch}
                    setClearSearch={setClearSearch}
                    searchedValue={searchValue}
                    filterOptions={[
                      {
                        key: 0,
                        label: "Filter by Created Date",
                        value: "created_date",
                        type: "date",
                      },
                      {
                        key: 1,
                        label: "Filter by GSM",
                        value: "gsm",
                        type: "inputSelect",
                      },
                      {
                        key: 2,
                        label: "Filter by Grade/Quality",
                        value: "grade_quality",
                        type: "grade",
                      },
                      {
                        key: 3,
                        label: "Filter by Burst Factor",
                        value: "burst_factor",
                        type: "inputSelect",
                      },
                      {
                        key: 4,
                        label: "Filter by Reel OD",
                        value: "reel_od",
                        type: "inputSelect",
                        unitType: "length",
                      },
                      {
                        key: 5,
                        label: "Filter by Core ID",
                        value: "core_id",
                        type: "inputSelect",
                        unitType: "length",
                      },
                      {
                        key: 6,
                        label: "Filter by Finishing Process Type",
                        value: "machine_type",
                        type: "multiSelect",
                      },
                    ]}
                    applyFilter={applyfilter}
                    hideExport={true}
                    showModifiedDateFilter={true}
                    modifiedFilterLabel={modifiedFilterLabel}
                    setModifiedFilterLabel={setModifiedFilterLabel}
                    storeModifiedFilterLabel={storeModifiedFilterLabel}
                    setStoreModifiedFilterLabel={setStoreModifiedFilterLabel}
                  />
                )}
                {(filterTags?.length ? filterTags : storedFilterTags)?.map((filter) => (
                  <span className="filter-tags">
                    <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                    &nbsp;
                    <span>{filter.formattedType}</span>
                    &nbsp;
                    <span>{filter.operand}</span>
                    &nbsp;
                    <span>{filter.value}</span>
                    <span>
                      {" "}
                      <button
                        onClick={() => {
                          removeFilter(filter);
                        }}
                      >
                        {" "}
                        <Iconmoon icon="wrong" size={15} color="#a8a8a8" />{" "}
                      </button>
                    </span>
                  </span>
                ))}
                <div className="board-canvas">
                  <div className="cardGroup">
                    {emptyStatePropsData ? (
                      <EmptyState
                        img={
                          emptyStateLabel === "noData" ||
                            emptyStateLabel === "filter"
                            ? emptyState_NoData
                            : emptyStateLabel === "search"
                              ? emptyState_Search
                              : emptyState_ConnectionAPIError
                        }
                        heading={emptyStatePropsData?.heading}
                        subHeading={emptyStatePropsData?.subHeading}
                        label={emptyStatePropsData?.label}
                        refresh={refresh}
                      />
                    ) : loadings ? (
                      coloumnDataJobCards.map((data) => {
                        return (
                          <JobListColumn>
                            <div className="jobListWrap">
                              <JobCardHeader className={data.classname}>
                                <h4>{data.heading}</h4>
                              </JobCardHeader>
                              {/* <SimpleBar className="cardRollers"> */}
                              <div
                                id={`scrollableDiv - ${data.state}`}
                                style={{ height: 950, overflow: "auto" }}
                              >
                                <InfiniteScroll
                                  dataLength={10}
                                  next={() => scrollHandler(data)}
                                  hasMore={data.hasMore}
                                  scrollableTarget={`scrollableDiv - ${data.state}`}
                                //loader={<h4>Loading...</h4>}
                                >
                                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(
                                    (item) => {
                                      return <CardShimmer details={item} />;
                                    }
                                  )}
                                </InfiniteScroll>
                              </div>
                              {/* </SimpleBar> */}
                            </div>
                          </JobListColumn>
                        );
                      })
                    ) : coloumnDataJobCards &&
                      (coloumnDataJobCards[0]?.jobcards?.length > 0 ||
                        coloumnDataJobCards[1]?.jobcards?.length > 0 ||
                        coloumnDataJobCards[2]?.jobcards?.length > 0 ||
                        coloumnDataJobCards[3]?.jobcards?.length > 0 ||
                        coloumnDataJobCards[4]?.jobcards?.length > 0) ? (
                      coloumnDataJobCards.map((data) => {
                        return (
                          <JobListColumn>
                            <div className="jobListWrap">
                              <JobCardHeader className={data.classname}>
                                <h4>{data.heading}</h4>
                              </JobCardHeader>
                              {/* <SimpleBar className="cardRollers"> */}
                              <div
                                id={`scrollableDiv - ${data.state}`}
                                style={{ height: 950, overflow: "auto" }}
                                ref={scrollContainerRef}
                              >
                                <InfiniteScroll
                                  dataLength={data.jobcards.length}
                                  next={() => scrollHandler(data)}
                                  hasMore={data.hasMore}
                                  scrollableTarget={`scrollableDiv - ${data.state}`}
                                  scrollThreshold={0.2}
                                //loader={<h4>Loading...</h4>}
                                >
                                  {data.jobcards.map((item) => {
                                    return <Cards details={item} />;
                                  })}
                                </InfiniteScroll>
                              </div>
                              {/* </SimpleBar> */}
                            </div>
                          </JobListColumn>
                        );
                      })
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </JobCardContainer>
        ) : (
          <TableLayoutData>
            <div className="tableDataFormat">
              <style dangerouslySetInnerHTML={{
                __html: `
                .ant-tabs, .ant-tabs-content-holder, .ant-tabs-content, .ant-tabs-tabpane {
                  overflow: visible !important;
                }
                .ant-table-sticky-holder {
                  z-index: 101 !important;
                }
              `}} />
              <StyledTab>
                <Tabs
                  defaultActiveKey="0"
                  onChange={handleTabChange}
                  destroyInactiveTabPane={true}
                  renderTabBar={(props, DefaultTabBar) => (
                    <div ref={tabRef} style={{ position: "sticky", top: stickyOffsets.tabs, zIndex: 99, background: "#fff" }}>
                      <DefaultTabBar {...props} />
                    </div>
                  )}
                >
                  {tabHead.map((tab) => (
                    <Panes tab={tab.title} key={tab.key}>
                      <div ref={searchRef} style={{ backgroundColor: "#fff" }}>
                        {!loadings && (
                          <SearchContainer
                            placeholder={"Search JobCard No"}
                            fetchOrder={searchOrders}
                            clearSearch={clearSearch}
                            setClearSearch={setClearSearch}
                            searchedValue={searchValue}
                            filterOptions={[
                              {
                                key: 0,
                                label: "Filter by Created Date",
                                value: "created_date",
                                type: "date",
                              },
                              {
                                key: 1,
                                label: "Filter by GSM",
                                value: "gsm",
                                type: "inputSelect",
                              },
                              {
                                key: 2,
                                label: "Filter by Grade/Quality",
                                value: "grade_quality",
                                type: "grade",
                              },
                              {
                                key: 3,
                                label: "Filter by Burst Factor",
                                value: "burst_factor",
                                type: "inputSelect",
                              },
                              {
                                key: 4,
                                label: "Filter by Reel OD",
                                value: "reel_od",
                                type: "inputSelect",
                                unitType: "length",
                              },
                              {
                                key: 5,
                                label: "Filter by Core ID",
                                value: "core_id",
                                type: "inputSelect",
                                unitType: "length",
                              },
                              {
                                key: 6,
                                label: "Filter by Finishing Process Type",
                                value: "machine_type",
                                type: "multiSelect",
                              },
                            ]}
                            applyFilter={applyfilter}
                            hideExport={true}
                            showModifiedDateFilter={true}
                            modifiedFilterLabel={modifiedFilterLabel}
                            setModifiedFilterLabel={setModifiedFilterLabel}
                            storeModifiedFilterLabel={storeModifiedFilterLabel}
                            setStoreModifiedFilterLabel={setStoreModifiedFilterLabel}
                          />
                        )}
                        {(filterTags?.length ? filterTags : storedFilterTags)?.map((filter) => (

                          <span className="filter-tags">
                            <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                            &nbsp;
                            <span>{filter.formattedType}</span>
                            &nbsp;
                            <span>{filter.operand}</span>
                            &nbsp;
                            <span>{filter.value}</span>
                            <span>
                              {" "}
                              <button
                                onClick={() => {
                                  removeFilter(filter);
                                }}
                              >
                                {" "}
                                <Iconmoon
                                  icon="wrong"
                                  size={15}
                                  color="#a8a8a8"
                                />{" "}
                              </button>
                            </span>
                          </span>
                        ))}
                      </div>
                      {loadings ? (
                        <TableShimmer
                          header={columnsHead}
                        // scroll={1000}
                        />
                      ) : tableData?.length ? (
                        <Table
                          sticky={{
                            offsetHeader: stickyOffsets.table,
                            getContainer: () => {
                              let node = document.getElementById('right-layout-container');
                              while (node && node !== document.body) {
                                const style = window.getComputedStyle(node);
                                if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                                node = node.parentNode;
                              }
                              return window;
                            }
                          }}
                          columns={columnsHead}
                          dataSource={tableData}
                          onChange={onChange}
                          pagination={{
                            current: paginationParams.page,
                            total: totalRecords,
                            showTitle: false,
                            defaultPageSize: 10,
                            pageSize: paginationParams.size,
                            showTotal: (total, range) =>
                              `Showing ${range[0]}-${range[1]} of ${total} results`,
                            pageSizeOptions: [10, 20, 50, 100],
                            showSizeChanger: true,
                            // locale: { items_per_page: "" },
                          }}
                          scroll={{ x: 1500 }}
                        />
                      ) : (
                        <EmptyState
                          img={
                            emptyStateLabel === "noData" ||
                              emptyStateLabel === "filter"
                              ? emptyState_NoData
                              : emptyStateLabel === "search"
                                ? emptyState_Search
                                : emptyState_ConnectionAPIError
                          }
                          heading={emptyStatePropsData?.heading}
                          subHeading={emptyStatePropsData?.subHeading}
                          label={emptyStatePropsData?.label}
                          refresh={refresh}
                        />
                      )}
                    </Panes>
                  ))}
                </Tabs>
              </StyledTab>
            </div>
          </TableLayoutData>
        ))}
    </RightLayoutContainer>
  ) : (
    ""
  );
};
export default JobCardsData;
